import React from "react";
import { useState, useEffect, useMemo, useCallback} from "react";
import { DataGrid, getGridNumericOperators, getGridDateOperators  } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { TextField } from '@mui/material';
import "./styles/ListarSesiones.css";
import { Link, useLocation, useParams } from 'react-router-dom';
import { esES } from '@mui/x-data-grid/locales';
import {Dialog,DialogTitle, DialogContent, DialogActions, Button, Typography, Divider, Grid} from '@mui/material';
import SubirSesiones from "./SubirSesiones";
import Swal from 'sweetalert2';


const AccionRenderer = ({sesion, verDetalles, solicitarEliminarSesion, manejarClickModificar}) => {
    return (
        <div style={{display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center'}}>
            
            <button className="botonTabla1Sesion" onClick={() => verDetalles(sesion)}>
                Ver
            </button>
            
            
            <button className="botonTabla2Sesion" onClick={() => manejarClickModificar(sesion)}>
                Modificar
            </button>
            
           
            <button className="botonTabla3Sesion" onClick={() => solicitarEliminarSesion(sesion)}>
                Eliminar
            </button>
        </div>
    )
}

const compararParte = (v1, v2) => {
    const valor1 = parseInt(v1);
    const valor2 = parseInt(v2);
    return valor1 - valor2;
}

const compararNombre = (v1, v2) => {
    const nombre1 = v1.toString();
    const nombre2 = v2.toString();
    return nombre1 > nombre2 ? 1 : nombre1 < nombre2 ? -1 : 0;
};

const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);

//Filtrar Fecha
function ValorFechaIntroducido(props) {
    const { item, applyValue, focusElementRef } = props;

    // Estado para la fecha
    const [fecha, setFecha] = useState(
        item.value
          ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
          : ''
      );
      const dateRef = React.useRef(null);

    React.useImperativeHandle(focusElementRef, () => ({
        focus: () => {
            if (dateRef.current) {
                dateRef.current.focus();
            }
        },
    }));

    const handleFilterChange = (event) => {
        const newValue = event.target.value; // Viene en "YYYY-MM-DD"
        setFecha(newValue);
        if (newValue === '') {
          applyValue({ ...item, value: null });
        } else {
          const dateObj = new Date(newValue);
          if (!isNaN(dateObj)) {
            applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
          } else {
            applyValue({ ...item, value: null });
          }
        }
    };
    
    return (
    <Box
        sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: 48,
            pl: '20px',
        }}
        >
        
        <TextField
            label="Fecha"
            type="date"
            value={fecha}
            onChange={handleFilterChange}
            inputRef={dateRef}
            InputLabelProps={{
                shrink: true,
            }}
        />
    </Box>
    );
}

//Grid tabla de sesiones
const GridSesiones = ({ sesiones, verDetalles, solicitarEliminarSesion, manejarClickModificar }) => {
    
    //La información que se mostrará en filas está en sesiones
    //Columnas
    const columns = useMemo(() => [
        {
            field: "parte",
            headerName: "Parte",
            width: 100,
            headerAlign: "center",  
            align: "center",
            renderCell: (params) => {
                const sesion = params.row;
                return sesion.Parte 
            },
            valueGetter: (value, row) => row.Parte,
            sortComparator: compararParte, 
            sortable: true,   
            filterable: true, 
        },
        {
            field: "nombre",
            headerName: "Nombre",
            width: 400,
            headerAlign: "center",  
            align: "center",
            renderCell: (params) => {
                const sesion = params.row;
                return sesion.Nombre; 
            },
            valueGetter: (value, row) => row.Nombre,
            sortComparator: compararNombre, 
            sortable: true,   
            filterable: true, 
        },
        {   
            field: "Fecha",
            headerName: "Fecha de transmisión",
            width: 200,
            headerAlign: "center",  
            align: "center",
            renderCell: (params) => {
                const rawFecha = params.row.Fecha;
                const fecha = new Date(rawFecha);
                if (isNaN(fecha)) return "Fecha inválida";
                return fecha.toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }).replace(/\//g, "-");
            },
            valueGetter: (value, row) => new Date(row.Fecha),
            sortComparator: compararFecha,
            sortable: true,   
            filterable: true,
            filterOperators: getGridDateOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    InputComponent: operator.InputComponent
                        ? ValorFechaIntroducido
                        : undefined,
                })),
        },
        {
            field: "Accion",
            headerName: "Accion",
            width: 345,
            headerAlign: "center",  
            align: "center",
            renderCell: (params) => <AccionRenderer sesion={params.row} verDetalles={verDetalles} solicitarEliminarSesion={solicitarEliminarSesion} manejarClickModificar={manejarClickModificar} />,
            sortable: false,   
            filterable: false, 
        },
    ]);

    return (
        <div className="gridContainerSesion">
            <DataGrid 
                rows={sesiones}
                columns={columns.map(col => ({
                    ...col,
                    headerAlign: 'center', // Centra el encabezado de la columna
                    align: 'center', // Centra el contenido de la celda
                }))}                
                pageSize={20}
                rowsPerPageOptions={[20]}
                disableSelectionOnClick
                getRowId={(row) => row._id}
                sx={{
                    borderColor: 'var(--text-principal)',
                    color: 'var(--text-principal)', 
                    fontSize: "14px",
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#fff',
                        color: 'black',
                        fontWeight: 'bold',
                        borderBottom: '0.25px solid var(--text-principal)',
                    },
                    "& .MuiTablePagination-displayedRows": {
                        color: "#fff", 
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: 'var(--text-principal)', 
                        fontWeight: "bold",
                    },
                    '& .MuiSvgIcon-root': {
                        color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                    },
                    '& .MuiDataGrid-sortIcon': {
                        color: 'black', // Cambia el color de la flecha de ordenación
                    },
                    '& .MuiDataGrid-menuIconButton svg': {
                        color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                    },
                    // 'Filas por página:' texto
                    "& .MuiTablePagination-selectLabel": {
                        color: 'var(--text-principal)',
                    },
                    // Selector desplegable (100)
                    "& .MuiInputBase-root": {
                        color: "var(--text-principal)",
                    },
                
                    // Opciones del selector al abrirse
                    "& .MuiMenuItem-root": {
                        color: "black", // texto de los items cuando se despliega el select
                    },
                
                    // '1–7 de 7'
                    "& .MuiTablePagination-displayedRows": {
                        color: "var(--text-principal)",
                    },
                
                    // Flechas de navegación
                    "& .MuiSvgIcon-root": {
                        color: "var(--text-principal)",
                    },
                    '& .MuiDataGrid-row': {
                        borderBottom: '0.25px solid var(--text-principal)', 
                    },
                    // Borde del selector si quieres quitarlo o estilizarlo
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fff",
                    },
                    // Icono del desplegable (flecha abajo del select)
                    "& .MuiSelect-icon": {
                        color: "var(--text-principal)",
                    },
                    // Icono menú cabecera
                    "& .MuiDataGrid-columnHeaderMenuIcon": {
                        color: "black",
                    },
                }}
                localeText={{
                    ...esES.components.MuiDataGrid.defaultProps.localeText,
                    rowsPerPage: "Filas por página:",
                }}  
            />
        </div>
    );
};


const ListarSesiones = () => {
    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    //Si viene desde listarContenido, lo leemos desde location.state
    const location = useLocation();
    const { clase } = location.state || {};

    //Si no, tomamos el id de la ruta
    const { id } = useParams();

    //Clase de la sesion, será la clase pasada por state o hacemos consulta
    const [claseSesion, setClaseSesion] = useState(null);

    //Lista de sesiones de la clase
    const [sesiones, setSesiones] = useState([]);

    //Carga de la página
    const [loading, setLoading] = useState(true);

    //Estado para controlar si se muestra formulario de modificación o no
    const [mostrarFormulario, setMostrarFormulario] = useState(false);

    //Estado para saber si se está editando o no al abrir el formulario
    const [editando, setEditando] = useState(false);

    //Datos a editar
    const [datosFormulario, setdatosFormulario] = useState(null);

    const [seleccion, setSeleccion] = useState(null); //Seleccionar producto
    const [abiertoDetalle, setAbiertoDetalle] = useState(false);  //Abrir modal
    const [confirmarEliminacion, setconfirmarEliminacion] = useState(false); //Abrir modal de eliminacion

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';

    //Datos clase
    const fetchClase = useCallback(async () => {
        setLoading(true);
        try {
        const res = await fetch(`${baseUrl}/api/clases/${id}`);
        if (!res.ok) throw new Error(res.statusText);
        const datos = await res.json();
        setClaseSesion(datos);
        } catch (error) {
        console.error("Error al obtener la clase:", error);
        setClaseSesion(null);
        } finally {
        setLoading(false);
        }
    }, [id]);

    //Sesiones de la clase
    const fetchSesionesDeLaClase = useCallback(async () => {
        if (!claseSesion?.Id_Sesion?.length) {
        setSesiones([]);
        return;
        }
        setLoading(true);
        try {
        const idsString = claseSesion.Id_Sesion.join(",");
        const res = await fetch(
            `${baseUrl}/api/sesiones/search/clase/${idsString}`
        );
        if (!res.ok) throw new Error(res.statusText);
        const datos = await res.json();
        datos.sort((a, b) => a.Parte - b.Parte);
        setSesiones(datos);
        } catch (error) {
        console.error("Error al obtener las sesiones:", error);
        setSesiones([]);
        } finally {
        setLoading(false);
        }
    }, [claseSesion]);

    //AL montar o cambiar estado
    useEffect(() => {
        if(clase){
            setClaseSesion(clase);
            setLoading(false);
        }
        else if(id){
            fetchClase();
        }
    }, [clase, id, fetchClase]);

     // Cuando cambie la clase, modificamos sesiones
    useEffect(() => {
        if (claseSesion) {
            fetchSesionesDeLaClase();
        }
    }, [claseSesion, fetchSesionesDeLaClase]);
    
    //Ver detalles de la sesion
    const manejarvistaDetalles = (sesion) => {
        setSeleccion(sesion);
        setAbiertoDetalle(true);
    }

    //Edición de contenido
    //Al pulsar modificar se abre el formulario
    const manejarClickModificar = (sesion) => {
        setdatosFormulario({Sesion: sesion, clase: claseSesion});
        setEditando(true);
        setMostrarFormulario(true);
    }

    //Inserción de contenido
    //Al pulsar insertar nuevas sesiones se abre el formulario
    const manejarClickInsertar = () => {
        setdatosFormulario({clase: claseSesion});
        setEditando(false);
        setMostrarFormulario(true);
    }

    //Cerrar/ocultar el formulario y limpiar
    const cerrarFormulario = () => {
        setMostrarFormulario(false);
        setEditando(false);
        setdatosFormulario(null);
    }

    //Eliminación de una sesion
    //Mostrar dialogo de eliminación
    const solicitarEliminarSesion = (sesion) => {
        if (sesiones.length <= 1) {
            Swal.fire({
                icon: 'warning',
                title: 'Operación no permitida',
                text: 'Una clase debe tener al menos una sesión; no puedes eliminar la última sesión.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        setAbiertoDetalle(false);
        setSeleccion(sesion);
        setconfirmarEliminacion(true);
    }

    //Eliminación de la sesion
    const manejarEliminacionSesion = async() => {
        try{
            const sesionId = seleccion._id;
            const claseId = claseSesion._id;
            const idsParam = claseSesion.Id_Sesion.map((i) => i.toString()).join(",");
            const url = `${baseUrl}/api/sesiones/${sesionId}/${claseId}/${idsParam}`
            
            const resp = await fetch(url, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!resp.ok) {
                const err = await resp.json();
                throw new Error(err.message || `HTTP ${resp.status}`);
            }

            setClaseSesion((cs) => ({
                ...cs,
                Id_Sesion: cs.Id_Sesion.filter((i) => i !== sesionId),
            }));
            await fetchSesionesDeLaClase();
            await Swal.fire({
                icon: 'success',
                title: '¡Sesión eliminada!',
                text: `La sesión "${seleccion.Nombre}" se ha eliminado correctamente.`,
                confirmButtonText: 'Aceptar'
            });
        } catch(error){
            console.error('Error al eliminar la sesión:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error en el servidor',
                text: 'Ha ocurrido un error al eliminar la sesión',
                confirmButtonText: 'Aceptar'
            });
        }
        finally{
            setconfirmarEliminacion(false);
            setSeleccion(null);
        }
    }

    //Cierre del dialogo de ver detalles
    const manejarCierre = () => {
        setAbiertoDetalle(false);
        setSeleccion(null);
    }


    if (!claseSesion) {
        return (
            <div className="principal">
                <h1>Cargando información de la clase…</h1>
            </div>
        );
    }

    return (
        <div className="principal">
            <h1>Sesiones de la clase {claseSesion.Nombre}</h1>   
            <div className="containerSesion">
                {loading ? (
                    <div className="noSesion">
                        <p>Cargando sesiones...</p>
                    </div>
                ) : sesiones.length === 0 ? (
                    <div className="noSesion">
                        <p>No existe ninguna sesión para esta clase</p>
                    </div>
                ) : (
                    <GridSesiones sesiones={sesiones} verDetalles={manejarvistaDetalles} solicitarEliminarSesion={solicitarEliminarSesion} manejarClickModificar={manejarClickModificar}/>
                )}
            </div>

            {/*Modal para ver detalles*/}
            <Dialog open={abiertoDetalle} onClose={manejarCierre} fullWidth maxWidth="md">
                <DialogTitle sx={{ textAlign: 'center' }}>{`Sesion ${seleccion?.Parte || ""} de la clase ${claseSesion.Nombre}`}</DialogTitle>
                <DialogContent dividers sx={{maxHeight: '70vh',overflowY: 'auto',}}>
                    {seleccion && (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Typography gutterBottom><strong>Nombre: </strong>{seleccion.Nombre}</Typography>
                                    <Typography gutterBottom>
                                        <strong>Fecha de transmisión: </strong>{new Date (seleccion.Fecha).toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        }).replace(/\//g, "-")}
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Hora de transmisión: </strong>{new Date (seleccion.Fecha).toLocaleTimeString("es-ES", {
                                            hour: "2-digit",
                                            minute: "2-digit"
                                        })}
                                    </Typography>

                                    <Typography gutterBottom> 
                                        <strong>Duración aproximada: </strong> {seleccion.Duracion} minutos 
                                    </Typography>
                                    
                                    <Typography gutterBottom>
                                        <strong>Enlace: </strong> {seleccion.Enlace} 
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Particular: </strong> {claseSesion.Particular ? 'Sí' : 'No' } 
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Nº plazas: </strong> {claseSesion.Plazas}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={manejarCierre}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            {/*Modal para eliminar reseña */}
            <Dialog
                open={confirmarEliminacion}
                onClose={() => setconfirmarEliminacion(false)}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    {`Eliminar ${seleccion?.Nombre}`}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        ¿Estás seguro de que deseas eliminar <strong>{seleccion?.Nombre}</strong> de la clase <strong>{claseSesion.Nombre}</strong>? Después no podrá deshacer el cambio.       
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={() => setconfirmarEliminacion(false)}>No</Button>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} color="error" onClick={manejarEliminacionSesion}>
                        Sí, eliminar
                    </Button>
                </DialogActions>
            </Dialog>

            {/*Modal para modificar e insertar sesiones */}
            <Dialog open={mostrarFormulario} maxWidth="lg" fullWidth PaperProps={{sx: {m: 0, borderRadius: 0, boxShadow: 'none'}}} BackdropProps={{sx: {backgroundColor: 'rgba(0,0,0,0.5)'}}}>
                <DialogActions sx={{justifyContent: "space-between", p: 1}}>
                    <Button onClick={cerrarFormulario}>X</Button>
                </DialogActions>
                <DialogContent sx={{ p: 0, height: "100%"}}>
                    <SubirSesiones
                        editando={editando}
                        datosIniciales={datosFormulario}
                        onClose={cerrarFormulario}
                        onSuccess={async (result) => {
                            // tras insertar o actualizar, volvemos a traer sesiones
                            cerrarFormulario();
                            
                            // si la clase sufrió cambio en su Id_Sesion, vuelve a consultar la clase:
                            await fetchClase();
                            await fetchSesionesDeLaClase();
                        }}
                    />
                </DialogContent>
            </Dialog>   
            
            <div className="contBotonInsertar">
                <button className="botonTabla" onClick={manejarClickInsertar}>Insertar nuevas sesiones</button>
            </div>
        </div>
    );
};



export default ListarSesiones;